import { useState, useEffect } from 'react';
import { Row, Col, Form, FormGroup, Label, Input, Media, Button } from 'reactstrap';
import { Btn, H6, Spinner } from 'AbstractElements';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PostCommon from 'Component/Learning/Common/Form/Post';
// import AsyncSelectCommon from 'Component/Learning/Common/SelectOption/AsyncSelect';
// import { fetchMainProgram } from 'Features/Learning/MainPrograms/Utils/MainProgramUtils';
import { submitMemberships } from 'Features/Learning/Memberships/Utils/MembershipUtils';
import { setField, resetState } from 'Features/Learning/Memberships/addMembershipSlice';
import { setFilters } from 'Features/Learning/Memberships/membershipSlice';
import Swal from 'sweetalert2';
import ModalAddProgram from './ModalAddProgram';
import RichEditor from 'Component/Editor/RichEditor/RichEditor';

const module = {
	'toolbar': [
		['bold', 'italic', 'underline', 'strike'],
		[{ 'color': [] }, { 'background': [] }],
		['clean'],
	],
	handlers: { 'emoji': function () { } }
}

const format = [
	'bold', 'italic', 'underline', 'strike', 'blockquote',
	'color', 'background',
];

const toolModule = {
	toolbar: module.toolbar
}

const createEmptyPoint = () => ({ name: '', status: false, description: '' });

const normalizePoint = (point) => ({
	name: point?.name || '',
	status: Boolean(point?.status),
	description: point?.description || '',
});

const hasEmptyPointName = (points) => points.some((point) => {
	const sanitizedName = point.name
		.replace(/<(.|\n)*?>/g, '')
		.replace(/&nbsp;/g, '')
		.trim();

	return sanitizedName === '';
});

const MembershipPostContain = (props) => {
	const dispatch = useDispatch();
	const history = useNavigate();
	const data = useSelector(state => state.addMembership)
	const detail = useSelector(state => state.Membership.detail)
	const startUpload = useSelector(state => state.addMembership.isLoading);
	const filters = useSelector(state => state.Membership.filters)
	// const filterMainProgram = useSelector(state => state.MainProgram.filters)
	const [selectedValue, setSelectedValue] = useState({});
	const [openProgram, setOpenProgram] = useState(false);
	const [localPoints, setLocalPoints] = useState(
		Array.isArray(data.points) && data.points.length > 0
			? data.points.map(normalizePoint)
			: [createEmptyPoint()]
	);

	const handleSuccess = () => {
		dispatch(resetState());
		history(`${process.env.PUBLIC_URL}/membership/membership-list`);
		dispatch(setFilters({
			...filters,
			'page': '1',
		}));
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		let errorMessage = '';

		if (data.title === '') {
			errorMessage = 'Nama Membership belum diisi.';
		} else if (data.price === '') {
			errorMessage = 'Harga Membership belum diisi.';
		} else if (data.duration_days === '') {
			errorMessage = 'Masa Aktif Membership belum diisi.';
		} else if (data.is_to_only === '') {
			errorMessage = 'Membership Hanya Berisi Tryout atau Tidak belum dipilih.';
		} else if (data.is_online === '') {
			errorMessage = 'Jenis Membership belum dipilih.';
		} else if (data.is_guaranteed === '') {
			errorMessage = 'Membership Bergaransi atau Tidak belum dipilih.';
		} else if (data.is_blacklist_referral === '') {
			errorMessage = 'Membership tidak bisa menggunakan referral atau Tidak belum dipilih.';
		} else if (data.is_guideline === '') {
			errorMessage = 'Membership punya Guide Line atau Tidak belum dipilih.';
		} else if (data.is_guideline === '1' && data.guideline_description === '') {
			errorMessage = 'Deskripsi Guide Line belum diisi.';
		} else if (data.main_program_id === '') {
			errorMessage = 'Program belum dipilih.';
		} else if (localPoints.length === 0 || hasEmptyPointName(localPoints)) {
			errorMessage = 'Fasilitas Membership ada yang belum diisi.';
		}

		if (data.title === '' || data.price === '' || data.duration_days === '' || data.is_to_only === '' || data.is_online === '' || data.is_guaranteed === '' || data.is_blacklist_referral === '' || data.is_guideline === '' || (data.is_guideline === '1' && data.guideline_description === '') || data.main_program_id === '' || localPoints.length === 0 || (localPoints.length > 0 && hasEmptyPointName(localPoints))) {
			Swal.fire({
				icon: 'error',
				title: 'Oops...',
				text: errorMessage,
			});
		} else {
			dispatch(submitMemberships({ ...data, points: localPoints, successCallback: handleSuccess }))
		}
	};

	const handleKeyDown = (e) => {
		// Hanya izinkan input angka (0-9) dan backspace
		const isValidInput = /^[0-9\b]+$/.test(e.key);

		if (!isValidInput && e.key !== 'Backspace') {
			e.preventDefault();
		}
	};

	const handleDiscard = (e) => {
		e.preventDefault();
		dispatch(resetState());
		history(`${process.env.PUBLIC_URL}/membership/membership-list`);
	};

	const handleChanges = (e) => {
		const { name, value } = e.target;
		dispatch(setField({ field: name, value: value }));
		// console.log(name, value);
	};

	const handleAddPoint = () => {
		setLocalPoints([...localPoints, createEmptyPoint()]);
	};
	const handleRemovePoint = (index) => {
		const updatedPoints = [...localPoints];
		updatedPoints.splice(index, 1);
		setLocalPoints(updatedPoints);
	};

	const handleChangePoint = (index, value) => {
		setLocalPoints((prevPoints) => {
			const updatedPoints = [...prevPoints];
			updatedPoints[index] = { ...updatedPoints[index], name: value };
			return updatedPoints;
		});
	};

	const handleChangePointDescription = (index, value) => {
		setLocalPoints((prevPoints) => {
			const updatedPoints = [...prevPoints];
			updatedPoints[index] = { ...updatedPoints[index], description: value };
			return updatedPoints;
		});
	};

	const handleStatus = (e, index) => {
		const { checked } = e.target;
		const updatedPoints = localPoints.map((point, i) =>
			i === index ? { ...point, status: checked } : point
		);
		setLocalPoints(updatedPoints);
	};

	// const handleSelectChange = (selectedOption) => {
	//     console.log(selectedOption)
	//     setSelectedValue(selectedOption);
	//     if (selectedOption === null) {
	//         dispatch(setField({ field: 'main_program_id', value: '' }));
	//         setSelectedValue(null);
	//     } else {
	//         dispatch(setField({ field: 'main_program_id', value: selectedOption.value }));
	//         setSelectedValue(selectedOption);
	//     }
	// };

	useEffect(() => {
		setSelectedValue((prevSelectedValue) => {
			if (data.main_program_id && detail.main_program) {
				return {
					id: detail.main_program.id,
					title: detail.main_program.title,
				};
			}

			return prevSelectedValue;
		});
		setLocalPoints(
			Array.isArray(data.points) && data.points.length > 0
				? data.points.map(normalizePoint)
				: [createEmptyPoint()]
		);
		// Inisialisasi points hanya jika belum ada data sama sekali
		// if (!Array.isArray(data.points) || data.points.length === 0) {
		//     dispatch(setField({ field: 'points', value: [{ name: '', status: false }] }));
		// }
	}, [data.id, data.main_program_id, data.points, detail.main_program]);

	// const promiseOptions = (inputValue, callback) => {
	//     dispatch(fetchMainProgram({
	//         ...filterMainProgram,
	//         'filter[title]': inputValue,
	//     }))
	//         .then((response) => {
	//             const options = response.payload.data.map(item => ({
	//                 value: item.id,
	//                 label: item.title,
	//             }));
	//             callback(options);
	//         })
	//         .catch((error) => {
	//             console.error('Error fetching options:', error);
	//             callback([]);
	//         });
	// };

	const handleOpenProgram = () => {
		setOpenProgram(!openProgram);
	};

	return (
		<PostCommon title={props.label} handleSubmit={handleSubmit} handleDiscard={handleDiscard} >
			{startUpload ? (
				<Col lg="12">
					<div className="loader-box">
						<Spinner attrSpinner={{ className: 'loader-30' }} />
					</div>
					<H6 attrH6={{ className: 'sub-title mb-0 text-center' }}>{'Sedang proses unggah...'}</H6>
				</Col>
			) : (
				<div>
					<Form className="row needs-validation">
						<Col sm="12">
							<FormGroup className='mb-3'>
								<Label for="validationName" style={{ fontWeight: 'bold' }}>Nama Membership:</Label>
								<Input className="form-control" id="validationName" type="text" name="title" placeholder="Masukkan nama membership..." required=""
									value={data.title}
									onChange={handleChanges} />
								<div className="valid-feedback">{'Looks good!'}</div>
							</FormGroup>
							<FormGroup className='mb-3'>
								<Label for="validationPrice" style={{ fontWeight: 'bold' }}>Harga:</Label>
								<Input className="form-control" id="validationPrice" type="text" name="price" placeholder="Masukkan harga membership..." required=""
									value={data.price}
									onChange={handleChanges}
									onKeyDown={handleKeyDown} />
								<div className="valid-feedback">{'Looks good!'}</div>
							</FormGroup>
							<FormGroup className='mb-3'>
								<Label for="validationGimmickPrice" style={{ fontWeight: 'bold' }}>Harga Coret:</Label>
								<Input className="form-control" id="validationGimmickPrice" type="text" name="gimmick_price" placeholder="Masukkan harga coret dari membership..."
									value={data.gimmick_price}
									onChange={handleChanges}
									onKeyDown={handleKeyDown} />
								<div className="valid-feedback">{'Looks good!'}</div>
							</FormGroup>
							<FormGroup className='mb-3'>
								<Label style={{ fontWeight: 'bold' }}>Posisi Harga Dibawah?</Label>
								<div className="m-checkbox-inline">
									<Label for="is_price_bottom_false">
										<Input className="radio_animated" id="is_price_bottom_false" type="radio" name="is_price_bottom" value="0"
											checked={data.is_price_bottom === '0'}
											onChange={handleChanges} />
										TIDAK
									</Label>
									<Label for="is_price_bottom_true">
										<Input className="radio_animated" id="is_price_bottom_true" type="radio" name="is_price_bottom" value="1"
											checked={data.is_price_bottom === '1'}
											onChange={handleChanges} />
										YA
									</Label>
								</div>
							</FormGroup>
							<FormGroup className='mb-3'>
								<Label for="validationSubHeader" style={{ fontWeight: 'bold' }}>Sub Judul:</Label>
								<Input className="form-control" id="validationSubHeader" type="textarea" name="subheader_desc" placeholder="Apa saja yang didapatkan?"
									value={data.subheader_desc || ''}
									onChange={handleChanges} />
								<div className="valid-feedback">{'Looks good!'}</div>
							</FormGroup>
							<FormGroup className='mb-3'>
								<Label for="validationDuration" style={{ fontWeight: 'bold' }}>Masa Aktif Membership (Hari):</Label>
								<Input className="form-control" id="validationDuration" type="text" name="duration_days" placeholder="Masukkan jumlah hari..." required=""
									value={data.duration_days}
									onChange={handleChanges}
									onKeyDown={handleKeyDown} />
								<div className="valid-feedback">{'Looks good!'}</div>
							</FormGroup>
							<FormGroup className='mb-3'>
								<Label for="validationSessionQuota" style={{ fontWeight: 'bold' }}>Session Quota:</Label>
								<Input className="form-control" id="validationSessionQuota" type="text" name="session_quota" placeholder="Masukkan kuota sesi (opsional)..."
									value={data?.session_quota || ''}
									onChange={handleChanges}
									onKeyDown={handleKeyDown} />
								<div className="valid-feedback">{'Looks good!'}</div>
							</FormGroup>
							<FormGroup className='mb-3'>
								<Label style={{ fontWeight: 'bold' }}>Membership Hanya Berisi Tryout?</Label>
								{detail && detail.is_to_only === '0' && detail.courses && detail.courses.length > 0 && (
									<div className="alert alert-danger" role="alert">
										<strong>Perhatian!</strong> Membership tidak dapat diubah menjadi 'hanya berisi tryout' jika sudah memiliki course.
									</div>
								)}
								<div className="m-checkbox-inline">
									<Label for="is_to_only_false">
										<Input className="radio_animated" id="is_to_only_false" type="radio" name="is_to_only" value="0"
											checked={data.is_to_only === '0'}
											onChange={handleChanges}
											disabled={detail && detail.is_to_only === '0' && detail.courses && data.courses.length > 0} />
										TIDAK
									</Label>
									<Label for="is_to_only_true">
										<Input className="radio_animated" id="is_to_only_true" type="radio" name="is_to_only" value="1"
											checked={data.is_to_only === '1'}
											onChange={handleChanges}
											disabled={detail && detail.is_to_only === '0' && detail.courses && detail.courses.length > 0} />
										YA
									</Label>
								</div>
							</FormGroup>
							<FormGroup className='mb-3'>
								<Label style={{ fontWeight: 'bold' }}>Jenis Membership:</Label>
								<div className="m-checkbox-inline">
									<Label for="is_online_false">
										<Input className="radio_animated" id="is_online_false" type="radio" name="is_online" value="0"
											checked={data.is_online === '0'}
											onChange={handleChanges} />
										Offline
									</Label>
									<Label for="is_online_true">
										<Input className="radio_animated" id="is_online_true" type="radio" name="is_online" value="1"
											checked={data.is_online === '1'}
											onChange={handleChanges} />
										Online
									</Label>
								</div>
							</FormGroup>
							<FormGroup className='mb-3'>
								<Label style={{ fontWeight: 'bold' }}>Membership Bergaransi?</Label>
								<div className="m-checkbox-inline">
									<Label for="is_guaranteed_false">
										<Input className="radio_animated" id="is_guaranteed_false" type="radio" name="is_guaranteed" value="0"
											checked={data.is_guaranteed === '0'}
											onChange={handleChanges} />
										TIDAK
									</Label>
									<Label for="is_guaranteed_true">
										<Input className="radio_animated" id="is_guaranteed_true" type="radio" name="is_guaranteed" value="1"
											checked={data.is_guaranteed === '1'}
											onChange={handleChanges} />
										YA
									</Label>
								</div>
							</FormGroup>
							<FormGroup className='mb-3'>
								<Label style={{ fontWeight: 'bold' }}>Membership tidak bisa menggunakan referral?</Label>
								<div className="m-checkbox-inline">
									<Label for="is_blacklist_referral_false">
										<Input className="radio_animated" id="is_blacklist_referral_false" type="radio" name="is_blacklist_referral" value="0"
											checked={data.is_blacklist_referral === '0'}
											onChange={handleChanges} />
										TIDAK
									</Label>
									<Label for="is_blacklist_referral_true">
										<Input className="radio_animated" id="is_blacklist_referral_true" type="radio" name="is_blacklist_referral" value="1"
											checked={data.is_blacklist_referral === '1'}
											onChange={handleChanges} />
										YA
									</Label>
								</div>
							</FormGroup>
							<FormGroup className='mb-3'>
								<Label style={{ fontWeight: 'bold' }}>Untuk Program Kerja Sama Kampus?</Label>
								<div className="m-checkbox-inline">
									<Label for="is_campus_event_false">
										<Input className="radio_animated" id="is_campus_event_false" type="radio" name="is_campus_event" value="0"
											checked={data.is_campus_event === '0'}
											onChange={handleChanges} />
										TIDAK
									</Label>
									<Label for="is_campus_event_true">
										<Input className="radio_animated" id="is_campus_event_true" type="radio" name="is_campus_event" value="1"
											checked={data.is_campus_event === '1'}
											onChange={handleChanges} />
										YA
									</Label>
								</div>
							</FormGroup>
							<FormGroup className='mb-3'>
								<Label style={{ fontWeight: 'bold' }}>Membership punya Guide Line?</Label>
								<div className="m-checkbox-inline">
									<Label for="is_guideline_false">
										<Input className="radio_animated" id="is_guideline_false" type="radio" name="is_guideline" value="0"
											checked={data.is_guideline === '0'}
											onChange={handleChanges} />
										TIDAK
									</Label>
									<Label for="is_guideline_true">
										<Input className="radio_animated" id="is_guideline_true" type="radio" name="is_guideline" value="1"
											checked={data.is_guideline === '1'}
											onChange={handleChanges} />
										YA
									</Label>
								</div>
							</FormGroup>
							{data.is_guideline === '1' && (
								<FormGroup className='mb-3'>
									<Label for="validationGuidelineDescription" style={{ fontWeight: 'bold' }}>Deskripsi Guide Line:</Label>
									<Input className="form-control" id="validationGuidelineDescription" type="textarea" name="guideline_description" placeholder="Masukkan deskripsi guide line..."
										value={data.guideline_description}
										onChange={handleChanges} />
								</FormGroup>
							)}
							{data.is_campus_event === '1' && (
								<FormGroup className='mb-3'>
									<Label for="validationLink" style={{ fontWeight: 'bold' }}>Link Pendaftaran:</Label>
									<Input className="form-control" id="validationLink" type="text" name="link" placeholder="Masukkan link pendaftaran..." required=""
										value={data.link}
										onChange={handleChanges} />
								</FormGroup>
							)}
							{/* <AsyncSelectCommon label={'Pilih Program'} placeholder={'Silahkan pilih Program...'}
                                isMulti={false}
                                promiseOptions={promiseOptions}
                                handleSelectChange={handleSelectChange}
                                selectedValue={selectedValue}
                            /> */}
							<Label className="col-form-label" style={{ fontWeight: 'bold' }}>Pilih Program :</Label>
							<Button color={Object.keys(selectedValue).length > 0 ? 'success' : 'primary'} style={{ display: "block", marginBottom: "20px" }} onClick={handleOpenProgram}>{Object.keys(selectedValue).length > 0 ? "Edit" : 'Pilih'} Program</Button>
							<ModalAddProgram openProgram={openProgram} handleOpenProgram={handleOpenProgram} selectedValue={selectedValue} setSelectedValue={setSelectedValue} />
							{localPoints.map((point, index) => (
								<FormGroup key={index} className='mb-3'>
									<Row>
										<Col>
											<Label for="validationPoint" style={{ fontWeight: 'bold' }}>
												Fasilitas Membership {index + 1}:
												{index > 0 && (
													<Btn
														attrBtn={{
															color: 'link',
															outline: true,
															className: 'p-1',
															onClick: () => handleRemovePoint(index)
														}}
													>
														<i className="fa fa-close mx-auto text-danger fa-2x"></i>
													</Btn>
												)}
											</Label>
											<RichEditor
												id={`validationChoice-${index}`}
												description={point.name}
												handleChangeDescription={value => handleChangePoint(index, value)}
												modules={toolModule}
												formats={format}
											/>
											<details className='mt-2'>
												<summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
													Tambahkan penjelasan fasilitas (opsional)
												</summary>
												<Input
													className='form-control mt-2'
													type='textarea'
													rows='3'
													placeholder='Masukkan penjelasan fasilitas jika diperlukan...'
													value={point.description || ''}
													onChange={(e) => handleChangePointDescription(index, e.target.value)}
												/>
											</details>
										</Col>
										<Col sm="1" className="text-center">
											<Label style={{ fontWeight: 'bold' }}>Status</Label>
											<Media body className="text-end icon-state">
												<Label className="switch">
													<Input type="checkbox" onChange={e => handleStatus(e, index)} checked={point.status || ''} name="status" /><span className="switch-state bg-primary"></span>
												</Label>
											</Media>
										</Col>
									</Row>
								</FormGroup>
							))}
							<FormGroup className='mb-3'>
								<Btn
									attrBtn={{
										color: 'link',
										outline: true,
										className: 'p-1',
										onClick: () => handleAddPoint()
									}}
								>
									<i className="fa fa-plus-circle mx-auto fa-2x" style={{ color: '#3C6F7D' }}></i>
								</Btn>
							</FormGroup>

						</Col>
					</Form>
				</div>
			)}
		</PostCommon>
	);
};

export default MembershipPostContain;